import { useEffect, useState, useCallback } from "react";
import api from "../api";

const STATUS = {
  confirmed: { label: "Confermato", color: "#16a34a" },
  pending: { label: "In attesa", color: "#d97706" },
  unsubscribed: { label: "Disiscritto", color: "#dc2626" },
  nessuno: { label: "Da contattare", color: "#64748b" },
};

function StatusPill({ s }) {
  const m = STATUS[s] || STATUS.nessuno;
  return <span className="badge" style={{ background: m.color + "22", color: m.color, border: `1px solid ${m.color}55` }}>{m.label}</span>;
}

export default function CompanyComms({ companyId, company, onReload }) {
  const [recips, setRecips] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get(`/companies/${companyId}/recipients`).then((r) => setRecips(r.data.recipients || [])).catch(() => {});
  }, [companyId]);
  useEffect(() => { load(); }, [load]);

  const toggleCompany = async (val) => {
    await api.put(`/companies/${companyId}`, { receives_comms: val });
    onReload && onReload(); load();
  };
  const togglePerson = async (personId, val) => {
    await api.put(`/persons/${personId}`, { receives_comms: val });
    load();
  };
  const send = async () => {
    const missing = recips.filter((r) => r.eligible && r.optin_status === "nessuno");
    if (missing.length === 0) { setMsg("Nessun nuovo destinatario da contattare."); return; }
    if (!window.confirm(`Inviare la richiesta di consenso a ${missing.length} destinatario/i? Chi conferma entrerà nel funnel.`)) return;
    setBusy(true); setMsg("");
    try {
      const r = await api.post(`/companies/${companyId}/send-consent`);
      setMsg(`Inviate ${r.data.sent} richieste · saltate ${r.data.skipped}.`);
      load();
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const companyRow = recips.find((r) => r.source === "azienda");
  const missingCount = recips.filter((r) => r.eligible && r.optin_status === "nessuno").length;

  return (
    <div className="panel" data-testid="company-comms-panel">
      <div className="toolbar">
        <h3 style={{ margin: 0 }}>Consenso &amp; funnel</h3>
        <div className="spacer" />
        <button className="btn primary" onClick={send} disabled={busy || missingCount === 0} data-testid="company-send-consent">
          Invia richiesta consenso{missingCount > 0 ? ` (${missingCount})` : ""}
        </button>
      </div>
      <p className="muted" style={{ fontSize: 13, marginTop: 2 }}>
        Email dell'azienda + soci/referenti idonei (esclusi consulenti del lavoro e PEC). Chi conferma il consenso entra automaticamente nel funnel.
      </p>

      <label className="optin-check" style={{ display: "flex", alignItems: "center", gap: 8, margin: "8px 0 4px" }}>
        <input type="checkbox" checked={company.receives_comms !== false} onChange={(e) => toggleCompany(e.target.checked)} data-testid="company-receives-comms" style={{ width: "auto" }} />
        <span>L'email dell'azienda riceve comunicazioni {company.email ? <em className="muted">({company.email})</em> : <em className="muted">(nessuna email azienda)</em>}</span>
      </label>

      <table style={{ marginTop: 10 }}>
        <thead><tr><th>Email</th><th>Nome / ruolo</th><th>Riceve</th><th>Stato consenso</th></tr></thead>
        <tbody>
          {recips.map((r) => (
            <tr key={r.email} data-testid={`comms-row-${r.email}`}>
              <td>{r.email}</td>
              <td>{r.name || "—"} <span className="muted">· {r.role}</span></td>
              <td>
                {r.source === "persona" ? (
                  <input type="checkbox" checked={r.eligible} onChange={(e) => togglePerson(r.person_id, e.target.checked)} data-testid={`comms-eligible-${r.email}`} style={{ width: "auto" }} />
                ) : (
                  <span className="muted">{r.eligible ? "sì" : "no"}</span>
                )}
              </td>
              <td><StatusPill s={r.optin_status} /></td>
            </tr>
          ))}
          {recips.length === 0 && <tr><td colSpan={4}><div className="empty">Nessuna email disponibile per quest'azienda.</div></td></tr>}
        </tbody>
      </table>
      {msg && <p className="muted" data-testid="company-comms-msg" style={{ marginTop: 8 }}>{msg}</p>}
    </div>
  );
}
